import { IconButton } from '@coolblue-development/becky';
import SendIcon from '../../../../../../assets/send.svg';

interface SendButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const SendButton = ({ onClick, isLoading, disabled }: SendButtonProps): JSX.Element => {
  return (
    <IconButton
      type="submit"
      data-testid="send-button"
      size="small"
      onClick={onClick}
      loading={isLoading}
      disabled={isLoading || disabled}
    >
      <SendIcon />
    </IconButton>
  );
};
